import { render, staticRenderFns } from "./safe-drawer-transfer.vue?vue&type=template&id=497efe98&scoped=true"
import script from "./safe-drawer-transfer.vue?vue&type=script&lang=js"
export * from "./safe-drawer-transfer.vue?vue&type=script&lang=js"
import style0 from "./safe-drawer-transfer.vue?vue&type=style&index=0&id=497efe98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497efe98",
  null
  
)

export default component.exports